// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"10499":"edb4faabf14dbd3d","42353":"7c896661b048fce5","44128":"7176684702ba1ea1","72935":"0ed7fb4e6df216e0","96181":"7a697876b8536d19"}[chunkId] + ".css";
};